import { Spin } from "antd";
import Loading from "../../assets/loading.gif";

export default function LoadingIcon() {
  const antIcon = <img className="h-20" src={Loading} alt="" />;
  return <Spin indicator={antIcon} />;
}
